import axiosInstance from "../axiosInstance";

export default async (token, email) => {
  await axiosInstance.post("/email/send-ver-email", null, {
    headers: { Authorization: `Bearer ${token}` },
  });
  alert(`Изпратен е имейл до ${email}`);
};
